import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import imgTest from "../assets/affiche.webp";
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import { PiAppStoreLogoBold } from 'react-icons/pi';
import { useState } from 'react';

export function Hero() {
  const { t } = useLanguage();
  const [activeButton, setActiveButton] = useState<'android' | 'ios'>('android');

  return (
    <section className="relative bg-gray-50 pt-20 pb-16">
      <div
        className="absolute inset-0 bg-[#0D3C4C]/5"
        style={{
          clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="md:mr-auto md:w-1/2 md:pr-10">
          <h2 className="text-3xl font-bold tracking-tight text-[#0D3C4C] sm:text-4xl lg:text-5xl">
            {t.hero.title}
          </h2>
          <p className="mt-6 max-w-md text-lg text-slate-700">
            {t.hero.subtitle}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <button 
              onClick={() => {
                window.open('https://play.google.com/store/apps/details?id=com.geniusvente.app', '_blank');
                setActiveButton('android');
              }}
              className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold shadow-sm border-2 border-[#0D3C4C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0D3C4C] transition-all duration-200 w-36 group
                ${activeButton === 'android' 
                  ? 'bg-[#0D3C4C] text-white' 
                  : 'bg-white text-[#0D3C4C]'
                }`}
            >
              <IoLogoGooglePlaystore className={`h-5 w-5 transition-colors ${activeButton === 'android' ? 'text-white' : 'text-[#0D3C4C]'}`} />
              <span className="font-semibold">{t.hero.downloadAndroid}</span>
            </button>
            <button 
              onClick={() =>{
                window.open('https://apps.apple.com/app/id6744921703', '_blank');
                setActiveButton('ios');
              } }
              className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold shadow-sm border-2 border-[#0D3C4C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0D3C4C] transition-all duration-200 w-36 group
                ${activeButton === 'ios' 
                  ? 'bg-[#0D3C4C] text-white' 
                  : 'bg-white text-[#0D3C4C]'
                }`}
            >
              <PiAppStoreLogoBold className={`h-5 w-5 transition-colors ${activeButton === 'ios' ? 'text-white' : 'text-[#0D3C4C]'}`} />
              <span className="font-semibold">{t.hero.downloadIOS}</span>
            </button>
          </div>
          <div className="flex items-center space-x-3 text-teal-600 mt-4">
            <Star className="fill-current" size={24} />
            <span className="text-lg">{t.hero.trialText}</span>
          </div>
        </div>
        <div className="mt-10 sm:mt-12 md:mt-0 md:absolute md:right-0 md:top-1/2 md:w-1/2 md:-translate-y-1/2">
          <img
            src={imgTest}
            alt="App screenshot"
            className="w-full"
          />
        </div>
      </div>
    </section>
  );
}
